export default {
  "contact.index.title": "LINK-J | Life Science Innovation Network Japan",
  "contact.index.description":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.index.ogSiteName": "LINK-J",
  "contact.index.ogTitle": "LINK-J | Life Science Innovation Network Japan",
  "contact.index.ogDescription":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.index.pageTitle": "Contact us",
  "contact.index.heading": "Agreed Terms",
  "contact.index.agreement1":
    "1. Personal information provided by customers shall be handled according to the Company's Personal Information ",
  "contact.index.privacyPolicy": "Protection Policy",
  "contact.index.and": " and ",
  "contact.index.privacyPurpose":
    "Concerning Protection of Personal Information",
  "contact.index.manageInfo": "",
  "contact.index.agreement2":
    "2. Personal information received from customers via the Company's Inquiry Form shall be used solely for the purpose of addressing customer inquiries. Depends on the inquiry, LINK-J's business partners, Mitsui Fudosan and Mitsui Fudosan Building Management may be better positioned to address customer inquiries.",
  "contact.index.agreement2Additional":
    "In such a case,please note that LINK-J may provide personal information to these business partners.",
  "contact.index.agreement3":
    "3. LINK-J's responses to customer inquiries shall not be reproduced, in part or in whole, without the permission of LINK-J.",
  "contact.index.agreement4":
    "4. Inquiries received on weekends or public holidays will be addressed the following business day.",
  "contact.index.agreement5":
    "5. Please refrain from making the inquiries regarding products or services.",
  "contact.index.agreeButton": "I agree with these terms",
  "contact.index.phoneFaxLabel": "TEL / FAX",
  "contact.index.telLabel": "TEL :",
  "contact.index.faxLabel": " FAX :",
  "contact.index.telNumber": "0332414911",
  "contact.index.telNumberText": "+81-3-3241-4911",
  "contact.index.faxNumberText": "+81-3-3241-3757",
  "contact.index.receptionHours":
    "Time in 9:00 a.m.- 5:00 p.m.／Saturdays, Sundays, holidays and our company holidays excluded.",

  "contact.form.title": "LINK-J | Life Science Innovation Network Japan",
  "contact.form.description":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.form.ogSiteName": "LINK-J",
  "contact.form.ogTitle": "LINK-J | Life Science Innovation Network Japan",
  "contact.form.ogDescription":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.form.pageTitle": "Contact us",
  "contact.form.heading": "Contact us",
  "contact.form.contactHeader": "",
  "contact.form.fullNameLabel": "Name",
  "contact.form.required": "required",
  "contact.form.lastNameLabel": "Last name",
  "contact.form.firstNameLabel": "First name",
  "contact.form.lastNameTitle": "please input Name(Last name)",
  "contact.form.firstNameTitle": "please input Name(First name)",
  "contact.form.fullNameKanaLabel": "",
  "contact.form.lastNameKanaLabel": "",
  "contact.form.firstNameKanaLabel": "",
  "contact.form.lastNameKanaTitle": "",
  "contact.form.firstNameKanaTitle": "",
  "contact.form.phoneLabel": "Phone",
  "contact.form.phoneTitle":
    "please input Phone (numeric and hyphen only.) eg. 0312345678",
  "contact.form.emailLabel": "E-Mail",
  "contact.form.emailTitle":
    "please input E-Mail (alphabet and numeric only.) eg. foo@example.com",
  "contact.form.emailConfirmNote": "Please re-enter to confirmation",
  "contact.form.emailConfirmTitle": "Please re-enter same value.",
  "contact.form.companyNameLabel": "Company Name",
  "contact.form.companyNameTitle": "please input Company Name",
  "contact.form.companyNameKanaLabel": "",
  "contact.form.companyNameKanaTitle": "",
  "contact.form.bodyLabel": "Comments",
  "contact.form.bodyTitle": "please input Comments",
  "contact.form.confirmButton": "Confirm",
  "contact.form.error.prefix": "Input error",

  "contact.confirm.title": "LINK-J | Life Science Innovation Network Japan",
  "contact.confirm.description":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.confirm.ogSiteName": "LINK-J",
  "contact.confirm.ogTitle": "LINK-J | Life Science Innovation Network Japan",
  "contact.confirm.ogDescription":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.confirm.pageTitle": "Contact us",
  "contact.confirm.heading": "Contact us",
  "contact.confirm.contactHeader": "",
  "contact.confirm.fullNameLabel": "Name",
  "contact.confirm.required": "required",
  "contact.confirm.fullNameKanaLabel": "",
  "contact.confirm.phoneLabel": "Phone",
  "contact.confirm.emailLabel": "E-Mail",
  "contact.confirm.companyNameLabel": "Company Name",
  "contact.confirm.companyNameKanaLabel": "",
  "contact.confirm.bodyLabel": "Comments",
  "contact.confirm.confirmationMessage":
    "Please review contents, and push submit button.",
  "contact.confirm.noScriptMessage": "",
  "contact.confirm.backButton": "Back",
  "contact.confirm.submitButton": "Send this contents",

  "contact.complete.title": "LINK-J | Life Science Innovation Network Japan",
  "contact.complete.description":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.complete.ogSiteName": "LINK-J",
  "contact.complete.ogTitle": "LINK-J | Life Science Innovation Network Japan",
  "contact.complete.ogDescription":
    "LINK-J (Life Science Innovation Network Japan) builds platforms centered in Nihonbashi for networking and exchanging information with people around the world. We serve people involved in life science research and its industry in the broad sense including preventative, presymptomatic and health and longevity medicine such as regenerative medicine, precision medicine, drug development, medical devices and healthcare IT.",
  "contact.complete.pageTitle": "Contact us",
  "contact.complete.heading": "Contact us",
  "contact.complete.sendComplete": "Mail transmission is completed.",
  "contact.complete.thankYou": "Thank you for your inquiry.",
  // "contact.complete.confirmationEmail": "Comfirmation email (auto-reply) will be sent from contact@link-j.org.", // original text
  "contact.complete.confirmationEmail":
    "Confirmation email (auto-reply) will be sent from contact@link-j.org.",
  "contact.complete.noEmailReceived": "",
  "contact.complete.salesInquiryNotice": "",
  "contact.complete.email": "E-mail : contact@link-j.org",
  "contact.complete.returnToHome": "Back to Top page",
} as const;
